export const API_URL = `https://trekstream-app.herokuapp.com`